export const makeSelectTestsTemplates = (state: AppState) => state.globalReducer.testsTemplates;
export const makeSelectLessonsTemplates = (state: AppState) => state.globalReducer.lessonsTemplates;
export const makeSelectWorksheetsTemplates = (state: AppState) =>
  state.globalReducer.worksheetsTemplates;
/* PAGINATION */
export const makeSelectLessonsPagination = (state: AppState) =>
  state.globalReducer.lessonsPagination;
export const makeSelectLocationsPagination = (state: AppState) =>
  state.globalReducer.locationsPagination;
export const makeSelectClassroomsPagination = (state: AppState) =>
  state.globalReducer.classroomsPagination;
export const makeSelectWorksheetsByCategoriesPagination = (state: AppState) =>
  state.globalReducer.worksheetsByCategory;

// Classrooms pagination
export const makeSelectClassroomLessonsPagination = (state: AppState) =>
  state.globalReducer.classroomLessonsPagination;
export const makeSelectClassroomTestsPagination = (state: AppState) =>
  state.globalReducer.classroomTestsPagination;
export const makeSelectClassroomWorksheetsPagination = (state: AppState) =>
  state.globalReducer.classroomWorksheetsPagination;
export const makeSelectClassroomStudentsPagination = (state: AppState) =>
  state.globalReducer.classroomStudentsPagination;

export const makeSelectInstructorsPagination = (state: AppState) =>
  state.globalReducer.instructorsPagination;
export const makeSelectInstructorStudentsPagination = (state: AppState) =>
  state.globalReducer.instructorStudentsPagination;

export const makeSelectCourseTemplatesPagination = (state: AppState) =>
  state.globalReducer.courseTemplatesPagination;
export const makeSelectWorksheetsPagination = (state: AppState) =>
  state.globalReducer.worksheetsPagination;

export const makeSelectStudentLessonsPagination = (state: AppState) =>
  state.globalReducer.studentLessonsPagination;
export const makeSelectStudentWorksheetsPagination = (state: AppState) =>
  state.globalReducer.studentWorksheetsPagination;
export const makeSelectStudentTestsPagination = (state: AppState) =>
  state.globalReducer.studentTestsPagination;
export const makeSelectStudentScoredTestsPagination = (state: AppState) =>
  state.globalReducer.studentScoredTestsPagination;
export const makeSelectStudentsPagination = (state: AppState) =>
  state.globalReducer.studentsPagination;

/* END OF PAGINATION */
export const makeSelectTemplateLoader = (state: AppState) => state.globalReducer.templateLoader;

export const makeSelectWorksheetsFilters = (state: AppState) =>
  state.globalReducer.worksheetsFilterItems;
export const makeSelectLessonsFilters = (state: AppState) => state.globalReducer.lessonsFilterItems;

export const makeSelectErrorSignal = (state: AppState) => state.globalReducer.errorSignal;
export const makeSelectSubjects = (state: AppState) => state.globalReducer.subjects;
/* Spinners */
export const makeSelectReportSpinner = (state: AppState) => state.globalReducer.reportSpinner;
export const makeSelectActionSpinner = (state: AppState) => state.globalReducer.actionSpinner;
export const makeSelectGlobalSpinner = (state: AppState) => state.globalReducer.globalSpinner;
export const makeSelectFetchSpinner = (state: AppState) => state.globalReducer.fetchSpinner;
export const makeSelectFetchDetailsSpinner = (state: AppState) =>
  state.globalReducer.fetchDetailsSpinner;
export const makeSelectFetchCalendarSpinner = (state: AppState) =>
  state.globalReducer.fetchCalendarSpinner;

export const makeSelectLessonsHints = (state: AppState) => state.globalReducer.lessonsHints;
export const makeSelectWorksheetsHints = (state: AppState) => state.globalReducer.worksheetsHints;
export const makeSelectFetchSublistSpinner = (state: AppState) =>
  state.globalReducer.fetchSublistSpinner;

export const makeSelectClassroomsSimplified = (state: AppState) =>
  state.globalReducer.classroomsSimplified;
export const makeSelectInstructorsSimplified = (state: AppState) =>
  state.globalReducer.instructorsSimplified;

export const makeSelectLocationsSimplified = (state: AppState) =>
  state.globalReducer.locationsSimplified;

export const makeSelectSimplifiedStudents = (state: AppState) =>
  state.globalReducer.studentsSimplified;

/* To be removed */

export const makeSelectUnitFilterOptions = (state: AppState) =>
  state.globalReducer.unitFilterOptions;

export const makeSelectCourses = (state: AppState) => state.globalReducer.courses;

export const makeSelectActiveCourse = (state: AppState) => state.globalReducer.activeCourse;

export const makeSelectLessonTemplatePreview = (state: AppState) =>
  state.globalReducer.lessonTemplatePreview;
export const makeSelectWorksheetTemplatePreview = (state: AppState) =>
  state.globalReducer.worksheetTemplatePreview;

export const makeSelectCategoryTree = (state: AppState) => state.globalReducer.categoriesTree;
